

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  fontFaceList,
  predefineColors,
  formAddList,
  shortFormAddList,
  countdownTimeOption,
  borderRadiusOptions,
  borderStyleOptions,
  typesettingOptions,
  typesettingOptions1,
  typesettingOptionsLeftRightOnly,
  fontSizeOptions,
  fontSizeSmallOptions,
  backgroundOptions,
  containerBorderRadiusOptions,
  POP_WINDOW_WHEEL_TYPE,
} from '../../../constant/options';
import YcColorPicker from '@/components/color-picker/index.js';
import compontentForm from '../../../components/form.vue';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import discountDialog from '../../../components/discountDialog.vue';
import { getCompanyInfo } from '@/model/CompanyInfo';
import EventBus from '@/utils/eventBus';
import { getFontFaceList } from '@/utils/getFontFaceList';
import TextAlignPicker from '@/components/text-align/index.vue';
import WheelOptionsCollapse from './WheelOptionsCollapse.vue';
import FontPicker from '@/components/FontPicker/index.vue';
import { getVueAppUploadApi } from '@/services/util';
import CloseButtonSetting from './CloseButtonSetting.vue';
import { DISABLE_CUSTOM_STEP_TPLID, DISABLE_CUSTOM_STEP_TPLID_NEW, DISABLE_SMS_SUBSCRIPTION_TPLID, isEnableAuth, isEnableCustomStep, isEnableFlowTfnSend, isEnableOnlyNewUserCustomStep, isEnablePrivacySetting, isEnableCloseButtonAdvanced, isEnableSmsDoubleCheck, isEnableWheelCouponSetting, isOnlyNewUserTemplate } from '@/utils/experiment';
import { getQueryVariable } from '@/services/api';
import { buildMiddlePageValue, getMiddlePageOrder, getMiddlePageScopedField, isCustomStepLimitExcludedForm, isEmailPhoneStepForm, isMiddlePage } from '../../utils/stepPages';
import CollapseArrow from './CollapseArrow.vue';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'compontent-form': compontentForm,
    discountDialog: discountDialog,
    'text-align-picker': TextAlignPicker,
    WheelOptionsCollapse,
    'font-picker': FontPicker,
    CloseButtonSetting,
    CollapseArrow
  }
})
export default class wheelOfFortuneTextStart extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  @Prop(Array)
  pageSettings!: any;

  @Prop(String)
  activePageSetting!: string;

  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;

  get currentFormKey() {
    return isMiddlePage(this.activePageSetting) ? this.activePageSetting : 'middle';
  }

  get isTieredDiscountTemplate() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return tid === '206';
  }

  get isTieredDiscountCouponPage() {
    return this.isTieredDiscountTemplate && this.currentFormKey === 'middle';
  }

  get isTieredDiscountFormPage() {
    return this.isTieredDiscountTemplate && !this.isTieredDiscountCouponPage;
  }

  get currentCouponPromptModel() {
    if (this.isTieredDiscountCouponPage) {
      return (this.formDataStart.settings.texts as any).middleCouponPrompt ?? '';
    }
    return this.formDataStart.settings.texts.couponPrompt;
  }

  set currentCouponPromptModel(value: string) {
    if (this.isTieredDiscountCouponPage) {
      this.$set(this.formDataStart.settings.texts as any, 'middleCouponPrompt', value);
      return;
    }
    this.$set(this.formDataStart.settings.texts as any, 'couponPrompt', value);
  }

  get currentCouponCodeModel() {
    if (this.isTieredDiscountCouponPage) {
      return (this.formDataStart.settings.rules as any).middleCouponCode ?? '';
    }
    return this.formDataStart.settings.rules.couponCode;
  }

  set currentCouponCodeModel(value: string) {
    if (this.isTieredDiscountCouponPage) {
      this.$set(this.formDataStart.settings.rules as any, 'middleCouponCode', value);
      return;
    }
    this.$set(this.formDataStart.settings.rules as any, 'couponCode', value);
  }

  get currentDiscountData() {
    if (this.isTieredDiscountCouponPage) {
      return (this.formDataStart.settings as any).middleDiscount;
    }
    return this.formDataStart.settings.discount;
  }

  get currentDiscountTypeModel() {
    if (this.isTieredDiscountCouponPage) {
      const settings = this.formDataStart.settings as any;
      return settings.middleDiscountType || (settings.middleDiscount ? 'dongtai' : 'guding');
    }
    return this.formDataStart.settings.discountType;
  }

  set currentDiscountTypeModel(value: string) {
    if (this.isTieredDiscountCouponPage) {
      this.$set(this.formDataStart.settings as any, 'middleDiscountType', value);
      if (value === 'guding') {
        this.$set(this.formDataStart.settings as any, 'middleDiscount', null);
      }
      return;
    }
    this.$set(this.formDataStart.settings as any, 'discountType', value);
  }

  get scopedRules(): any {
    const rules = this.formDataStart.settings.rules as any;
    const pageKey = this.currentFormKey;
    if (pageKey === 'middle') return rules;
    return new Proxy(rules, {
      get(target, prop: string) {
        const scopedKey = getMiddlePageScopedField(pageKey, prop);
        return scopedKey !== prop ? (target[scopedKey] ?? target[prop]) : target[prop];
      },
      set(target, prop: string, value) {
        const scopedKey = getMiddlePageScopedField(pageKey, prop);
        // 写入前，如果 scoped 字段还不存在，先用当前回退值初始化一次，确保后续修改不影响其他步骤
        if (scopedKey !== prop && typeof target[scopedKey] === 'undefined' && typeof target[prop] !== 'undefined') {
          Vue.set(target, scopedKey, target[prop]);
        }
        Vue.set(target, scopedKey, value);
        return true;
      }
    });
  }

  /** 确保 styleMap 中所有 __middle 后缀的 key 都有对应的 scoped 独立副本 */
  private ensureStyleMapScopedEntries() {
    const styleMap = this.formDataStart?.settings?.styles?.styleMap as any;
    const pageKey = this.currentFormKey;
    if (!styleMap) return;

    // 仅对 middle 之外的中间页(middle2/middle3...),从 middle 拷贝一份独立配置
    if (pageKey !== 'middle') {
      const middleKeys = Object.keys(styleMap).filter(k => k.includes('__middle'));
      for (const key of middleKeys) {
        const scopedKey = key.replace(/__middle/g, `__${pageKey}`);
        if (scopedKey !== key && typeof styleMap[scopedKey] === 'undefined') {
          const source = styleMap[key];
          const copy = source && typeof source === 'object'
            ? JSON.parse(JSON.stringify(source))
            : {};
          Vue.set(styleMap, scopedKey, copy);
        }
      }
    }

    const ensureEntry = (key: string, fallbackKeys: string[], defaultValue: any = {}) => {
      if (typeof styleMap[key] !== 'undefined') return;
      const sourceKey = fallbackKeys.find((item) => styleMap[item] !== undefined);
      const source = sourceKey ? styleMap[sourceKey] : defaultValue;
      Vue.set(styleMap, key, source && typeof source === 'object' ? JSON.parse(JSON.stringify(source)) : {});
    };

    ensureEntry(`cartx-b-show__${pageKey}`, ['cartx-b-show__middle', 'cartx-b-show'], { background: '#ffffff' });
    ensureEntry(`cartx-b-wheel-container__${pageKey}`, ['cartx-b-wheel-container__middle', 'cartx-b-wheel-container']);
    ensureEntry(`cartx-b-title__${pageKey}`, ['cartx-b-title__middle', 'cartx-b-title']);
    ensureEntry(`cartx-b-subtitle__${pageKey}`, ['cartx-b-subtitle__middle', 'cartx-b-subtitle']);
    ensureEntry(`cartx-b-activity__${pageKey}`, ['cartx-b-activity__middle']);
    ensureEntry(`cartx-b-input__${pageKey}`, ['cartx-b-input__middle', 'cartx-b-input'], { 'font-family': 'Arial, sans-serif' });
    ensureEntry(`cartx-b-privacy__${pageKey}`, ['cartx-b-privacy__middle', 'cartx-b-privacy']);
    ensureEntry(`cartx-b-privacy-check__${pageKey}`, ['cartx-b-privacy-check__middle', 'cartx-b-privacy-check']);
    ensureEntry(`cartx-b-button__${pageKey}`, ['cartx-b-button__middle', 'cartx-b-button']);
    ensureEntry(`cartx-b-show__${pageKey} .cartx-b-button__${pageKey}`, [
      'cartx-b-show__middle .cartx-b-button__middle',
      'cartx-b-show .cartx-b-button'
    ]);
    ensureEntry(`cartx-b-thanks__${pageKey}`, ['cartx-b-thanks__middle', 'cartx-b-thanks']);
    // SKA2792: 折扣码区块中间页独立样式(与结束页 cartx-b-complete-* 解耦)
    ensureEntry(`cartx-b-coupon-prompt__${pageKey}`, ['cartx-b-coupon-prompt__middle', 'cartx-b-coupon-prompt']);
    ensureEntry(`cartx-b-complete-1__${pageKey}`, ['cartx-b-complete-1__middle', 'cartx-b-complete-1']);
    ensureEntry(`cartx-b-complete-text-1__${pageKey}`, ['cartx-b-complete-text-1__middle', 'cartx-b-complete-text-1']);
    ensureEntry(`cartx-b-complete-2__${pageKey}`, ['cartx-b-complete-2__middle', 'cartx-b-complete-2']);
    ensureEntry(`cartx-b-show__${pageKey} .cartx-b-complete-1__${pageKey}`, ['cartx-b-show__middle .cartx-b-complete-1__middle', 'cartx-b-show .cartx-b-complete-1']);
    ensureEntry(`cartx-b-show__${pageKey} .cartx-b-complete-2__${pageKey}`, ['cartx-b-show__middle .cartx-b-complete-2__middle', 'cartx-b-show .cartx-b-complete-2']);
  }

  get pageStyleMap(): any {
    const styleMap = this.formDataStart?.settings?.styles?.styleMap as any;
    if (!styleMap) return {};
    this.ensureStyleMapScopedEntries();
    return styleMap;
  }

  getScopedRuleKey(field: string) {
    return getMiddlePageScopedField(this.currentFormKey, field);
  }

  ensureScopedRuleDefault(field: string, valueFactory: () => any) {
    const rules = this.formDataStart?.settings?.rules as any;
    if (!rules) return;
    const scopedKey = this.getScopedRuleKey(field);
    if (typeof rules?.[scopedKey] === 'undefined') {
      Vue.set(rules, scopedKey, valueFactory());
    }
  }

  ensureDropdownRuleDefaults() {
    if (!this.formList.some((item: any) => item.type === '自定义' && item.questionType === 'Dropdown')) return;
    const defaults = {
      middleDropdownTitleFontSize: '16px',
      middleDropdownTitleFontFamily: 'Arial, sans-serif',
      middleDropdownBorderStyle: 'solid',
      middleDropdownBorderColor: '#C5C4CE',
      middleDropdownBorderRadius: '4px',
      middleDropdownBackgroundType: '',
      middleDropdownBackgroundColor: '#FFFFFF',
      middleDropdownOptionTextColor: '#1d2129'
    };
    Object.keys(defaults).forEach((key) => {
      this.ensureScopedRuleDefault(key, () => defaults[key]);
    });
  }

  ensureMarginRuleDefaults() {
    const rules = this.formDataStart?.settings?.rules as any;
    if (!rules) return;
    const defaults = {
      middleInputMarginTop: 0,
      middleInputMarginLeft: 0,
      middleInputMarginBottom: 14,
      middleInputMarginRight: 0,
      middleOptionMarginTop: 0,
      middleOptionMarginLeft: 0,
      middleOptionMarginBottom: 14,
      middleOptionMarginRight: 0,
      middleDropdownMarginTop: 0,
      middleDropdownMarginLeft: 0,
      middleDropdownMarginBottom: 14,
      middleDropdownMarginRight: 0
    };
    Object.keys(defaults).forEach((key) => {
      this.ensureScopedRuleDefault(key, () => defaults[key]);
    });
  }

  get formList() {
    return ((this.formDataStart?.settings as any)?.[this.currentFormKey] || []) as any[];
  }

  set formList(val: any[]) {
    Vue.set(this.formDataStart.settings as any, this.currentFormKey, val || []);
  }

  get currentFormList() {
    return this.formList;
  }

  getMiddleTypesettingValue(field: string) {
    const ts = this.formDataStart?.settings?.typesetting as any;
    const key = getMiddlePageScopedField(this.currentFormKey, field);
    return ts?.[key] ?? ts?.[field];
  }

  setMiddleTypesettingValue(field: string, val: any) {
    const ts = this.formDataStart?.settings?.typesetting as any;
    if (!ts) return;
    const key = getMiddlePageScopedField(this.currentFormKey, field);
    Vue.set(ts, key, val);
  }

  getMiddleScopedValue(container: any, field: string) {
    const key = getMiddlePageScopedField(this.currentFormKey, field);
    return container?.[key] ?? container?.[field];
  }

  setMiddleScopedValue(container: any, field: string, val: any) {
    if (!container) return;
    const key = getMiddlePageScopedField(this.currentFormKey, field);
    Vue.set(container, key, val);
  }

  get currentMiddleImgUrl() {
    return this.getMiddleTypesettingValue('middleImgUrl');
  }

  set currentMiddleImgUrl(val: string) {
    this.setMiddleTypesettingValue('middleImgUrl', val);
  }

  get currentMiddleBgImgUrl() {
    return this.getMiddleTypesettingValue('middleBgImgUrl');
  }

  set currentMiddleBgImgUrl(val: string) {
    this.setMiddleTypesettingValue('middleBgImgUrl', val);
  }

  get currentMiddleLeftAdImage() {
    return this.getMiddleTypesettingValue('middleLeftAdImage');
  }

  set currentMiddleLeftAdImage(val: string) {
    this.setMiddleTypesettingValue('middleLeftAdImage', val);
  }

  get currentMiddleRightAdImage() {
    return this.getMiddleTypesettingValue('middleRightAdImage');
  }

  set currentMiddleRightAdImage(val: string) {
    this.setMiddleTypesettingValue('middleRightAdImage', val);
  }

  get currentMiddleLogoImgUrl() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.logo as any, 'middleImgUrl');
  }

  set currentMiddleLogoImgUrl(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.logo as any, 'middleImgUrl', val);
  }

  get currentMiddleTextAreaImgUrl() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleTextAreaImgUrl');
  }

  set currentMiddleTextAreaImgUrl(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleTextAreaImgUrl', val);
  }

  get currentMiddleTopTitle() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleTopTitle');
  }

  set currentMiddleTopTitle(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleTopTitle', val);
  }

  get currentMiddleTopSubTitle() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleTopSubTitle');
  }

  set currentMiddleTopSubTitle(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleTopSubTitle', val);
  }

  get currentMiddleActivityTitle() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleActivityTitle');
  }

  set currentMiddleActivityTitle(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleActivityTitle', val);
  }

  get currentMiddleMainButton() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleMainButton');
  }

  set currentMiddleMainButton(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleMainButton', val);
  }

  get currentMiddleSubButton() {
    return this.getMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleSubButton');
  }

  set currentMiddleSubButton(val: string) {
    this.setMiddleScopedValue(this.formDataStart?.settings?.texts as any, 'middleSubButton', val);
  }

  get currentMiddleImgPosition() {
    return this.getMiddleTypesettingValue('middleImgPosition');
  }

  set currentMiddleImgPosition(val: string) {
    this.setMiddleTypesettingValue('middleImgPosition', val);
  }

  get currentMiddleBgbox() {
    return this.getMiddleTypesettingValue('middleBgbox');
  }

  set currentMiddleBgbox(val: boolean) {
    this.setMiddleTypesettingValue('middleBgbox', val);
  }

  get currentMiddleBgboxColor() {
    return this.getMiddleTypesettingValue('middleBgboxColor');
  }

  set currentMiddleBgboxColor(val: string) {
    this.setMiddleTypesettingValue('middleBgboxColor', val);
  }

  // 选择框选项
  get formAddList() {
    if (this.formData.settings.combinationType == 2) {
      return formAddList.filter(item => {
        if (item.label != 'Email') {
          return item;
        }
      });
    } else {
      return formAddList;
    }
  }
  /** popWindowWheel=WHEEL_COMBO：中间页按侧图转盘组合逻辑展示 */
  get isPopWheelCombo2Middle() {
    return Number(this.formDataStart?.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO;
  }
  shortFormAddList = shortFormAddList;
  countdownTimeOption = countdownTimeOption;
  predefineColors = predefineColors;
  fontFaceList = getFontFaceList(fontFaceList);
  borderRadiusOptions = borderRadiusOptions;
  borderStyleOptions = borderStyleOptions;
  typesettingOptions = typesettingOptions;
  fontSizeOptions = fontSizeOptions;
  fontSizeSmallOptions = fontSizeSmallOptions;
  backgroundOptions = backgroundOptions;
  typesettingOptions1 = typesettingOptions1;
  typesettingOptionsLeftRightOnly = typesettingOptionsLeftRightOnly;
  containerBorderRadiusOptions = containerBorderRadiusOptions;
  POP_WINDOW_WHEEL_TYPE = POP_WINDOW_WHEEL_TYPE;

  countdownTime: string = 'minute';
  countDown: number = 5;
  collapseArr = ['1', '2'];
  emailOpen: boolean = this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'start';
  couponCodeShow: boolean = this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'start';
  compontentFormIsShow = false;
  formType = {};

  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  bgUploadFileList: { name: string; url: string }[] = [];
  bgUploadShow = false;
  logoUploadFileList: { name: string; url: string }[] = [];
  logoUploadShow = false;
  leftAdImageFileList: { name: string; url: string }[] = [];
  leftAdImageShow = false;
  rightAdImageFileList: { name: string; url: string }[] = [];
  rightAdImageShow = false;
  textAreaUploadShow = false;
  textAreaFileList: { name: string; url: string }[] = [];

  zpbgUploadFileList: { name: string; url: string }[] = [];
  zpbgUploadShow = false;
  pointUploadFileList: { name: string; url: string }[] = [];
  pointUploadShow = false;

  showDiscountDialog = false;

  // 第三方登录提供商配置
  authProviders = [
    {
      type: 2,
      name: 'Google',
      label: 'Sign in with Google',
      icon: require('@/assets/img/auth/google.svg'),
      placeholder: '请输入 Google Client ID'
    }
  ];

  // wheelOptionsCollapse同步
  onWheelOptionsChange(list: any[]) {
    console.log('onWheelOptionsChange', list);
    this.formDataStart.settings.discountList = list;
    this.changeStart();
  }

  get enableAuth() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    const triggerEventType = this.formData.triggerEventType;
    const hasEmail = this.currentFormList.find((item: any) => item.type === 'Email');
    return isEnableAuth() && hasEmail && (
      (triggerEventType === 2 && tid === '98') ||
      (triggerEventType === 0 && this.formData.type === 'POP_WINDOW')
    );
  }

  get enableMiddleButtonOtherActions() {
    return getCompanyInfo().id === 1291;
  }

  get enableFormOptimize() {
    return true;
  }

  get enableCloseButtonAdvanced() {
    return isEnableCloseButtonAdvanced();
  }

  handleCloseButtonChange(config: any) {
    // 同步更新 scoped 关闭按钮颜色（按当前页 key 落到 middle2CloseColor 等）
    if (config && config.iconColor) {
      this.scopedRules.middleCloseColor = config.iconColor;
    }
    this.changeStart();
    window?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  get enableWheelCouponSetting() {
    return isEnableWheelCouponSetting() && this.formDataStart.settings.discountList && this.formDataStart.popWindowWheel === POP_WINDOW_WHEEL_TYPE.WHEEL;
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  get enableInputFontFamily() {
    return true;
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1
  }

  get enableSmsSubscription() {
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    // 新订阅用户发放券包、大转盘模板、嵌入式表单、多步骤采集模板不进行本次功能新增
    return isEnableFlowTfnSend() && !DISABLE_SMS_SUBSCRIPTION_TPLID.includes(templateId) && this.triggerEventType !== 7 && !this.isTieredDiscountFormPage;
  }

  get showSmsCoiSwitch() {
    return isEnableSmsDoubleCheck();
  }

  get enableMobileRatio() {
    return true;
  }

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    return isEnableOnlyNewUserCustomStep() && isOnlyNewUserTemplate(templateId);
  }

  get useShortFormAddList() {
    return !this.stepDisplayDisabled || this.isPopZhuanpan || this.customStepLimitExcluded || this.triggerEventType === 7 || this.enableOnlyNewUserCustomStep;
  }

  get customStepLimitExcluded() {
    return isCustomStepLimitExcludedForm(this.formDataStart, getQueryVariable('templateid') || this.formDataStart?.templateId);
  }

  get enableCustomStep() {
    if (!isEnableCustomStep() || [3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    if (this.enableOnlyNewUserCustomStep) {
      return !DISABLE_CUSTOM_STEP_TPLID_NEW.includes(templateId);
    }
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  /** 是否存在第二步（中间页）：分步开启或 pageSettings 含 middle */
  get hasMiddleStepPage(): boolean {
    const rules = (this.formData || this.formDataStart)?.settings?.rules;
    if (rules?.stepDisplay) return true;
    const pages = this.pageSettings || [];
    if (pages.some((p: any) => p?.value === 'middle' || /^middle\d*$/i.test(String(p?.value || '')))) {
      return true;
    }
    const middle = (this.formData || this.formDataStart)?.settings?.middle;
    return Array.isArray(middle) && middle.length > 0;
  }

  /**
   * 第二步倒计时开关是否展示：
   * - 须存在中间页（stepDisplay / middle）
   * - popWindowWheel=2 不展示（侧图+转盘组合，与线上一致）
   * - popWindowWheel=1 等分步弹窗：第一步 countDownShow 为总开关
   */
  get showMiddleCountDownSettingBlock(): boolean {
    if (this.triggerEventType === 7) return false;
    if (!this.hasMiddleStepPage) return false;
    if (this.isPopWheelCombo2) return false;
    const rules = (this.formData || this.formDataStart)?.settings?.rules;
    if (!rules) return false;
    if (rules.countDownShow === true) return true;
    if (rules.countDownShow === false) return false;
    const countDownSec = Number(rules.countDown);
    return !Number.isNaN(countDownSec) && countDownSec > 0;
  }

  get company33aPopDisable() {
    const disablePop =
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 33 && this.formData?.id == '55abadf02473424aa42004745e4b74f6') ||
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 30 && this.formData?.id == '8eaf5e5c7d244b65bc9843e98f33d08d');
    return disablePop;
  }

  get companyis535() {
    const status = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id === 535;
    return status;
  }

  get shopType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (companyInfo.integrationType) {
      return companyInfo.integrationType?.toLowerCase();
    }
    return ``;
  }

  get formStyle() {
    const rules = this.scopedRules;
    const styleMap = this.pageStyleMap;
    const pk = this.currentFormKey;
    const inputStyle = styleMap['cartx-b-input__' + pk];
    const privacyStyle = styleMap['cartx-b-privacy__' + pk];
    const privacyCheckStyle = styleMap['cartx-b-privacy-check__' + pk];
    const textAlignMap: Record<string, string> = {
      'left': 'flex-start',
      'center': 'center',
      'right': 'flex-end',
    };
    const optionColumns = Math.max(1, Math.min(3, Number(rules.middleOptionColumns || 1)));
    const optionColumnGap = 16;
    const optionFlexBasis = optionColumns === 1 ? '100%' : 'auto';

    return `
      .cartx-form[data-form-type="options"] {
        margin-top: ${(rules.middleOptionMarginTop ?? 0)}px !important;
        margin-bottom: ${(rules.middleOptionMarginBottom ?? 14)}px !important;
        margin-left: ${(rules.middleOptionMarginLeft ?? 0)}px !important;
        margin-right: ${(rules.middleOptionMarginRight ?? 0)}px !important;
      }
      .cartx-form[data-form-type="input"] {
        margin-top: ${(rules.middleInputMarginTop ?? 0)}px !important;
        margin-bottom: ${(rules.middleInputMarginBottom ?? 14)}px !important;
        margin-left: ${(rules.middleInputMarginLeft ?? 0)}px !important;
        margin-right: ${(rules.middleInputMarginRight ?? 0)}px !important;
      }
      .cartx-form[data-form-type="dropdown"] {
        margin-top: ${(rules.middleDropdownMarginTop ?? 0)}px !important;
        margin-bottom: ${(rules.middleDropdownMarginBottom ?? 14)}px !important;
        margin-left: ${(rules.middleDropdownMarginLeft ?? 0)}px !important;
        margin-right: ${(rules.middleDropdownMarginRight ?? 0)}px !important;
      }
      .cartx-question-option-list {
        display: flex !important;
        flex-wrap: wrap !important;
        column-gap: ${optionColumnGap}px !important;
        row-gap: 8px !important;
        text-align: left !important;
      }
      .cartx-option-columns:not(.cartx-privacy){
        min-width: 0 !important;
        max-width: 100% !important;
        flex: 0 0 ${optionFlexBasis} !important;
        margin: 0 !important;
        color: ${rules.middleOptionTextColor || rules.middleOptionColor}!important;
        display: inline-flex !important;
        align-items: center !important;
        white-space: normal !important;
        ${rules.middleOptionFontFamily ? `font-family: ${rules.middleOptionFontFamily} !important;` : ''}
        ${rules.middleOptionFontSize ? `font-size: ${rules.middleOptionFontSize} !important;` : ''}
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__input,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__input {
        display: inline-flex !important;
        align-items: center !important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__label,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__label {
        color: ${rules.middleOptionTextColor || rules.middleOptionColor}!important;
        display: inline-flex !important;
        align-items: center !important;
        line-height: 1.2 !important;
        ${rules.middleOptionFontFamily ? `font-family: ${rules.middleOptionFontFamily} !important;` : ''}
        ${rules.middleOptionFontSize ? `font-size: ${rules.middleOptionFontSize} !important;` : ''}
      }
      .cartx-option-columns:not(.cartx-privacy):not(:last-child) {
        margin-bottom: 0 !important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__inner,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__inner {
        border-color: #C5C4CE !important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.middleOptionTextColor || rules.middleOptionColor}!important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.middleOptionBackground}!important;
        background: ${rules.middleOptionBackground}!important;
      }
      .cartx-question:not(.cartx-dropdown-title) {
        color: ${rules.middleOptionTitleColor || rules.middleOptionColor}!important;
        ${rules.middleOptionFontFamily ? `font-family: ${rules.middleOptionFontFamily} !important;` : ''}
        ${rules.middleOptionTitleFontSize ? `font-size: ${rules.middleOptionTitleFontSize} !important;` : ''}
      }
      .cartx-form[data-form-type="input"] > div > .el-input:not(.cartx-b-show-mobile-number) {
        // width: calc(100% - ${rules.middleInputMarginLeft || 0}px - ${rules.middleInputMarginRight || 0}px) !important;
      }
      
      .cartx-form > div > span > .cartx-form-phone-starPhone {
        left: 4px !important;
        top: 53% !important;
        transform: translateY(-50%) !important;
      }
      .cartx-form .el-input__inner {
        border-width: ${rules.middleInputType === 'bottom' ? '0 0 1px 0' : '1px'}!important;
        border-style: ${rules.middleInputBorderStyle}!important;
        border-color: ${rules.middleInputBorderColor}!important;
        border-radius: ${rules.middleInputBorderRadius}!important;
        background: ${rules.middleInputBackgroundShow !== 'none' ? rules.middleInputBackground : 'none'}!important;
        color: ${rules.middleInputColor}!important;
        ${inputStyle['font-family'] ? `font-family: ${inputStyle['font-family']} !important;` : ''}
      }
      .cartx-form[data-form-type="input"] input::placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input::-webkit-input-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input:-moz-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input::-moz-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input:-ms-input-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form .cartx-dropdown-select {
        border: none !important;
        background: none !important;
      }
      .cartx-form .cartx-dropdown-select .el-input__inner {
        border-width: 1px !important;
        border-style: ${typeof rules.middleDropdownBorderStyle !== 'undefined' ? rules.middleDropdownBorderStyle : 'solid'} !important;
        border-color: ${typeof rules.middleDropdownBorderColor !== 'undefined' ? rules.middleDropdownBorderColor : '#C5C4CE'} !important;
        border-radius: ${typeof rules.middleDropdownBorderRadius !== 'undefined' ? rules.middleDropdownBorderRadius : '4px'} !important;
        background: ${rules.middleDropdownBackgroundType !== 'none' ? (typeof rules.middleDropdownBackgroundColor !== 'undefined' ? rules.middleDropdownBackgroundColor : '#FFFFFF') : 'none'} !important;
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'} !important;
        margin: 0 !important;
      }
      // 下拉菜单占位符颜色独立，透明度与输入框占位符保持一致
      .cartx-dropdown-select input::placeholder {
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input::-webkit-input-placeholder {
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input:-moz-placeholder {
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input::-moz-placeholder {
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input:-ms-input-placeholder {
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-popper .el-select-dropdown__item {
        color: ${typeof rules.middleDropdownOptionTextColor !== 'undefined' ? rules.middleDropdownOptionTextColor : '#1d2129'} !important;
      }
      .cartx-form .cartx-question.cartx-dropdown-title {
        line-height: 22px;
        margin-bottom: 8px;
        font-weight: 400;
        ${rules.middleDropdownTitleColor ? `color: ${rules.middleDropdownTitleColor} !important;` : ''}
        ${rules.middleDropdownTitleFontSize ? `font-size: ${rules.middleDropdownTitleFontSize} !important;` : ''}
        ${rules.middleDropdownTitleFontFamily ? `font-family: ${rules.middleDropdownTitleFontFamily} !important;` : ''}
      }

      ${this.enablePrivacySetting ? `
        .cartx-form[data-form-type="privacy"] {
          margin-top: ${privacyStyle['margin-top'] ?? -8}px !important;
          margin-bottom: ${privacyStyle['margin-bottom'] ?? 0}px !important;
          margin-left: ${privacyStyle['margin-left'] ?? 0}px !important;
          margin-right: ${privacyStyle['margin-right'] ?? 0}px !important;
        }
        .cartx-privacy-new-wrapper {
          color: ${privacyStyle['color']} !important;
          background-color: ${privacyStyle['background-color']} !important;
          padding-top: ${privacyStyle['padding-top'] || 0}px !important;
          padding-bottom: ${privacyStyle['padding-bottom'] || 0 }px  !important;
          padding-left: ${privacyStyle['padding-left'] || 0}px  !important;
          padding-right: ${privacyStyle['padding-right'] || 0}px  !important;
          min-width: unset !important;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          align-items: ${textAlignMap[privacyStyle?.['text-align'] || 'left']};
        }
        .cartx-privacy-new-wrapper .cartx-option-columns.cartx-privacy-new {
          padding: 1px 0;
          border-radius: 0;
          background-color: unset;
          margin: 0;
        }
        .cartx-privacy-new-wrapper .cartx-option-columns.cartx-privacy-new {
          max-height: 43px;
        }
        .cartx-option-columns.cartx-privacy-new .tipsSpan {
          font-family: ${privacyStyle['font-family']} !important;
          font-size: ${privacyStyle['font-size']} !important;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input {
          height: 14px;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input .el-checkbox__inner,
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input .el-radio__inner {
          border-color: ${privacyStyle['color']} !important;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input.is-checked .el-checkbox__inner,
        .cartx-option-columns.cartx-privacy-new .el-radio__input.is-checked .el-radio__inner {
          border-color: ${privacyCheckStyle['color']} !important;
          background: ${privacyCheckStyle['color']} !important;
        }
        .cartx-option-columns.cartx-privacy-new.cartx-privacy-is-check-box .el-checkbox__input {
          top: 1px
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__label {
          flex: 1;
        }
      `: ''}
    `;
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  get showLeftRightAdImage() {
    return ['35', '49'].includes(`${Number(this.$route.query.templateid) || this.formData.templateId}`);
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return (
      this.formData.popWindowWheel === POP_WINDOW_WHEEL_TYPE.WHEEL ||
      tid === '36' ||
      tid === '37' ||
      tid === '38' ||
      tid === '39' ||
      tid === '40' ||
      tid === '42' ||
      tid === '43' ||
      `${this.formData.id}` === '1e1609bc024d4517989039886ac7ed34' ||
      `${this.formData.id}` === 'abdac5d809824d8280ffff395a854a15'
    );
  }

  // popWindowWheel=WHEEL_COMBO：转盘组合布局（在步骤二中隐藏活动文案配置）
  get isPopWheelCombo2() {
    return Number(this.formDataStart?.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO;
  }

  get middleLeftAdImageDisabled() {
    const disabled = this.currentMiddleLeftAdImage || this.leftAdImageShow;
    return disabled;
  }

  get middleRightAdImageDisabled() {
    const disabled = this.currentMiddleRightAdImage || this.rightAdImageShow;
    return disabled;
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return ((companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681)) && this.triggerEventType !== 3;
  }

  gaClickFun(key:string,name:string){
    window?.gtagClick(key,name)
  }

  changeDiscountType() {
    // console.log('changeDiscountType', this.formDataStart.settings.discountType);
    if (this.currentDiscountTypeModel === 'guding') {
      if (this.isTieredDiscountCouponPage) {
        this.$set(this.formDataStart.settings as any, 'middleDiscount', null);
      } else {
        this.formDataStart.settings.discount = null;
      }
    } else {
      this.showDiscountDialog = true;
    }
    // this.formDataStart.settings.discountType = 'guding';

    // 发送事件通知其他组件
    EventBus.$emit('discount-type-changed', this.currentDiscountTypeModel);
    this.changeStart();
  }
  showDiscountDialogHandle() {
    this.showDiscountDialog = true;
  }
  saveDiscount(discount: any) {
    if (this.isTieredDiscountCouponPage) {
      this.$set(this.formDataStart.settings.rules as any, 'middleCouponCode', '');
      this.$set(this.formDataStart.settings as any, 'middleDiscount', discount);
      this.$set(this.formDataStart.settings as any, 'middleDiscountType', 'dongtai');
    } else {
      this.formDataStart.settings.rules.couponCode = '';
      this.formDataStart.settings.discount = discount;
      this.formDataStart.settings.discountType = 'dongtai';
    }
    // 发送事件通知
    EventBus.$emit('discount-type-changed', 'dongtai');
    this.showDiscountDialog = false;
    this.changeStart();
  }
  closeDiscount() {
    if (this.currentDiscountTypeModel === 'guding') {
      this.currentDiscountTypeModel = 'guding';
      this.changeStart();
    }
    this.showDiscountDialog = false;
  }

  changcompontentFormIsShow(e: boolean) {
    this.compontentFormIsShow = e;
  }

  addFormAddList(item: any, index: number) {
    if (this.collapseArr.indexOf('1') < 0) {
      this.collapseArr.push('1');
    }
    if (item.type !== '自定义') {
      let a = this.formList.filter((i: any) => {
        return i.type === item.type;
      });

      if (a.length > 0) {
        this.formType = a[0];
        this.compontentFormIsShow = true;
        return;
      }
      // 检查其他步骤页是否存在相同表单
      let b =
        [
          ...(this.formDataStart.settings.start || []),
          ...(this.formDataStart.settings.end || [])
        ].filter((i: any) => {
          return i.type === item.type;
        }) || [];
      if (b.length > 0) {
        this.$message.error('您添加了多个' + item.label + '表单，请检查设置是否有误');
        return;
      }
    }

    if (this.formList.length < 8) {
      this.formType = item;
      this.compontentFormIsShow = true;
    } else {
      this.$message.error('最多只能添加8个表单');
    }
    window?.gtagClick('form_edit_selectField_'+item?.label.replace(/\s/g, ''),'弹窗_编辑订阅工具_选择采集项_'+item?.label.replace(/\s/g, ''))
  }

  //倒计时计算
  changecountDownShow() {
    if (this.countdownTime === 'minute') {
      this.formDataStart.settings.rules.countDown = this.countDown * 60;
    } else if (this.countdownTime === 'second') {
      this.formDataStart.settings.rules.countDown = this.countDown;
    }
    window?.gtagClick('form_edit_CountdownTimerEditor', '弹窗_编辑订阅工具_设置倒计时器组件');
    this.changeStart();
  }

  changeFormList(e: any) {
    Vue.set(this.formDataStart.settings as any, this.currentFormKey, e);
    this.ensureDropdownRuleDefaults();
    this.ensureMarginRuleDefaults();
    if (this.stepDisplayDisabled) {
      Vue.set(this.formDataStart.settings.rules, 'stepDisplay', false);
    }
    this.changeStart();
  }

  changeImgPosition() {
    if (this.currentMiddleImgPosition !== 'background') {
      this.currentMiddleBgbox = false;
    }
    this.changeStart();
  }

  changeStart() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }

  changeStartGA() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }

  changeStartWithGtag(key: string, name: string) {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick(key, name);
  }

  changeOptionFontFamily(val: string) {
    this.$set(this.scopedRules, 'middleOptionFontFamily', val);
    this.changeStartWithGtag('form_edit_selectField_option_font', '弹窗_编辑订阅工具_选择采集项_选项_字体');
  }

  changeCouponCodePosition() {
    if (this.couponCodeShow) {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.$message.warning('结束页面已经展示coupon');
        this.couponCodeShow = false;
      } else {
        this.formDataStart.settings.rules.couponCodePosition = 'start';
        this.formDataStart.settings.rules.couponCodeShow = this.couponCodeShow;
      }
    } else {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.formDataStart.settings.rules.couponCodePosition = 'end';
      } else {
        this.formDataStart.settings.rules.couponCodePosition = '';
      }
    }
    this.changeStart();
  }

  changeCouponCodeType() {
    this.changeStart();
  }

  blurPointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
  }

  changePointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
    this.changeStart();
  }

  get stepDisplayDisabled() {
    return !isEmailPhoneStepForm(this.formData.settings.start || [], this.formData.settings.end);
  }

  // 当开始页按钮交互切换为“显示下一步骤”或其他选项时，更新页面设置
  handleButtonActionChange() {
    this.normalizeTieredDiscountFormPage();
    const action = this.scopedRules.middleButtonAction;

    if (action === 'sms') {
      window?.gtagClick('form_edit_btnActionSmsSub', '弹窗_编辑订阅工具_设置按钮交互为通过短信订阅');
      if (typeof this.formDataStart.settings.rules.smsSubBody === 'undefined') {
        this.$set(
          this.formDataStart.settings.rules as any,
          'smsSubBody',
          'Send this text to subscribe to recurring automated personalized marketing alerts (e.g. cart reminders) from XXXX'
        );
      }
      if (typeof this.formDataStart.settings.rules.breakSmsDoubleCheck === 'undefined') {
        this.$set(this.formDataStart.settings.rules as any, 'breakSmsDoubleCheck', true);
      }
    }

    if (action === 'open') {
      this.pageSettings.forEach((item: any) => {
        if (item.value === 'end') {
          // 启用结束页：恢复不透明度
          item.opacity = 1;
        }
      });
    } else {
      this.pageSettings.forEach((item: any) => {
        if (item.value === 'end') {
          // 禁用结束页：降低不透明度
          item.opacity = 0.3;
        }
      });
    }

    this.changeStart();
  }

  normalizeTieredDiscountFormPage() {
    if (!this.isTieredDiscountFormPage) {
      return;
    }
    if (this.scopedRules.middleButtonAction !== 'open') {
      this.scopedRules.middleButtonAction = 'open';
    }
    const currentPhone = this.formList.find((item: any) => item.type === 'Mobile Number');
    if (this.formList.length !== 1 || !currentPhone) {
      const defaultPhone = shortFormAddList.find((item: any) => item.type === 'Mobile Number') || formAddList.find((item: any) => item.type === 'Mobile Number');
      this.formList = [JSON.parse(JSON.stringify(currentPhone || defaultPhone))];
    }
  }

  @Watch('currentMiddleImgUrl', { immediate: true })
  typesettingImgUrlChange(val: string) {
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.bgUploadShow = false;
      this.bgUploadFileList = [];
    }
  }
  @Watch('currentMiddleBgImgUrl', { immediate: true })
  typesettingBGImgUrlChange(val: string) {
    if (val) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.zpbgUploadShow = false;
      this.zpbgUploadFileList = [];
    }
  }
  @Watch('formData.settings.typesetting.pointImgUrl', { immediate: true })
  typesettingPointImgUrlChange(val: string) {
    if (val) {
      this.pointUploadShow = true;
      this.pointUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('currentMiddleLogoImgUrl', { immediate: true })
  logoImgUrlChange(val: string) {
    if (val) {
      this.logoUploadShow = true;
      this.logoUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.logoUploadShow = false;
      this.logoUploadFileList = [];
    }
  }

  @Watch('currentMiddleLeftAdImage', { immediate: true })
  leftAdImageUrlChange(val: string) {
    if (val) {
      this.leftAdImageShow = true;
      this.leftAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.leftAdImageShow = false;
      this.leftAdImageFileList = [];
    }
  }

  @Watch('currentMiddleRightAdImage', { immediate: true })
  rightAdImageUrlChange(val: string) {
    if (val) {
      this.rightAdImageShow = true;
      this.rightAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.rightAdImageShow = false;
      this.rightAdImageFileList = [];
    }
  }

  @Watch('currentMiddleTextAreaImgUrl', { immediate: true })
  textAreaImgUrlChange(val: string) {
    if (val) {
      this.textAreaUploadShow = true;
      this.textAreaFileList = [
        {
          name: '',
          url: val
        }
      ];
    } else {
      this.textAreaUploadShow = false;
      this.textAreaFileList = [];
    }
  }

  @Watch('formData.settings.rules.emailOpen')
  emailOpenChange(val: boolean) {
    if (val === true && this.formData.settings.rules.emailPosition === 'start') {
      this.emailOpen = true;
    } else {
      this.emailOpen = false;
      if (this.formData.settings.rules.emailPosition === 'end') {
        this.formDataStart.settings.rules.emailPosition = 'end';
      } else {
        this.formDataStart.settings.rules.emailPosition = '';
      }
    }
  }

  @Watch('formData.settings.rules.emailPosition')
  emailPositionChange(val: string) {
    this.emailOpen = this.formData.settings.rules.emailOpen === true && val === 'start';
  }

  @Watch('formData.settings.rules.couponCodeShow')
  couponCodeShowChange(val: boolean) {
    this.couponCodeShow = val === true && this.formData.settings.rules.couponCodePosition === 'start';
  }

  @Watch('formData.settings.rules.couponCodePosition')
  couponCodePositionChange(val: string) {
    this.couponCodeShow = this.formData.settings.rules.couponCodeShow === true && val === 'start';
  }

  created() {
    this.formDataStart = this.formData;
    this.normalizeTieredDiscountFormPage();
  }

  mounted() {
    console.log('textMiddle mounted')
    this.formDataStart = this.formData;
    this.normalizeTieredDiscountFormPage();
    // 调试：组件加载后主动打印一次当前分支命中
    void this.currentCollectFormOptions;
    this.ensureDropdownRuleDefaults();
    this.ensureMarginRuleDefaults();
    if (this.isTieredDiscountCouponPage) {
      this.currentDiscountTypeModel = (this.formDataStart.settings as any).middleDiscount ? 'dongtai' : 'guding';
    } else if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }

    // 设置移动端广告位比例默认值（$set 保证响应式，触发 popNew 预览更新）
    if (!this.scopedRules.middleMobileRatio && this.enableMobileRatio) {
      this.ensureScopedRuleDefault('middleMobileRatio', () => {
        const rules = this.formDataStart?.settings?.rules as any;
        return rules?.middleMobileRatio || 'recommendRatio';
      });
    }
    if (Number(this.formDataStart.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO) {
      this.ensureScopedRuleDefault('middleMobilePictureShow', () => {
        const rules = this.formDataStart?.settings?.rules as any;
        return rules?.middleMobilePictureShow ?? false;
      });
    }

    // 确保中间页倒计时开关字段是响应式的（用于预览实时生效）
    this.ensureScopedRuleDefault('middleCountDownShow', () => {
      const rules = this.formDataStart?.settings?.rules as any;
      return rules?.middleCountDownShow ?? this.formDataStart.settings.rules.countDownShow ?? false;
    });

    // 确保中间页关闭按钮颜色/高级配置 scoped 字段响应式（middle2/3/4 独立配置兜底）
    this.ensureScopedRuleDefault('middleCloseColor', () => {
      const rules = this.formDataStart?.settings?.rules as any;
      return rules?.middleCloseColor || '#333333';
    });
    this.ensureScopedRuleDefault('middleCloseButtonConfig', () => {
      const rules = this.formDataStart?.settings?.rules as any;
      return rules?.middleCloseButtonConfig
        ? { ...rules.middleCloseButtonConfig }
        : { position: 'right-top', bgMode: 'none', bgColor: 'rgba(0,0,0,0)', iconColor: '#333333', size: '18px' };
    });

    // 确保 authList 存在
    if (!this.formDataStart.settings.authList) {
      this.$set(this.formDataStart.settings, 'authList', []);
    }

    // 确保短信订阅相关字段存在（用于按钮交互：通过短信订阅）
    if (typeof this.formDataStart.settings.rules.smsSubBody === 'undefined') {
      this.$set(
        this.formDataStart.settings.rules as any,
        'smsSubBody',
        'Send this text to subscribe to recurring automated personalized marketing alerts (e.g. cart reminders) from XXXX'
      );
    }
    if (typeof this.formDataStart.settings.rules.breakSmsDoubleCheck === 'undefined') {
      this.$set(this.formDataStart.settings.rules as any, 'breakSmsDoubleCheck', true);
    }
    // 新模板下，步骤二默认开启适配推荐
    if (Number(this.formDataStart.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO && typeof this.scopedRules.middleAdapterText === 'undefined') {
      this.ensureScopedRuleDefault('middleAdapterText', () => {
        const rules = this.formDataStart?.settings?.rules as any;
        return rules?.middleAdapterText ?? true;
      });
    }
    // 转盘组合 2：中间页侧图仅左/右
    if (Number(this.formDataStart.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO && this.formDataStart?.settings?.typesetting) {
      this.scopedRules.middleMobilePictureShow = false;
      const ts = this.formDataStart.settings.typesetting;
      const positionKey = getMiddlePageScopedField(this.currentFormKey, 'middleImgPosition');
      const currentValue = (ts as any)[positionKey] ?? ts.middleImgPosition;
      if (!(currentValue === 'left' || currentValue === 'right')) {
        Vue.set(ts as any, positionKey, 'right');
      }
    }

    this.handlePrivacyPositionChange();
  }

  @Watch('formData.settings.rules.countDownShow')
  onStartCountDownShowChange(val: boolean | undefined) {
    this.formDataStart = this.formData;
    if (val && typeof this.formDataStart.settings.rules.middleCountDownShow === 'undefined') {
      this.$set(this.formDataStart.settings.rules, 'middleCountDownShow', true);
    }
  }

  @Watch('formData', { immediate: true })
  changeFormData() {
    this.formDataStart = this.formData;
    this.normalizeTieredDiscountFormPage();
    this.ensureDropdownRuleDefaults();
    this.ensureMarginRuleDefaults();
    // if (!this.formDataStart.settings.discountType) {
    if (this.isTieredDiscountCouponPage) {
      this.currentDiscountTypeModel = (this.formDataStart.settings as any).middleDiscount ? 'dongtai' : 'guding';
    } else if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }

    // 设置移动端广告位比例默认值（$set 保证响应式，触发 popNew 预览更新）
    if (!this.scopedRules.middleMobileRatio && this.enableMobileRatio) {
      this.ensureScopedRuleDefault('middleMobileRatio', () => {
        const rules = this.formDataStart?.settings?.rules as any;
        return rules?.middleMobileRatio || 'recommendRatio';
      });
    }
    if (Number(this.formDataStart.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO) {
      this.ensureScopedRuleDefault('middleMobilePictureShow', () => {
        const rules = this.formDataStart?.settings?.rules as any;
        return rules?.middleMobilePictureShow ?? false;
      });
    }
    // 新模板下，步骤二默认开启适配推荐
    if (Number(this.formDataStart.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO && typeof this.scopedRules.middleAdapterText === 'undefined') {
      this.ensureScopedRuleDefault('middleAdapterText', () => {
        const rules = this.formDataStart?.settings?.rules as any;
        return rules?.middleAdapterText ?? true;
      });
    }
    // 确保中间页关闭按钮颜色/高级配置 scoped 字段响应式（formData 切换时重新兜底）
    this.ensureScopedRuleDefault('middleCloseColor', () => {
      const rules = this.formDataStart?.settings?.rules as any;
      return rules?.middleCloseColor || '#333333';
    });
    this.ensureScopedRuleDefault('middleCloseButtonConfig', () => {
      const rules = this.formDataStart?.settings?.rules as any;
      return rules?.middleCloseButtonConfig
        ? { ...rules.middleCloseButtonConfig }
        : { position: 'right-top', bgMode: 'none', bgColor: 'rgba(0,0,0,0)', iconColor: '#333333', size: '18px' };
    });
    if (Number(this.formDataStart.popWindowWheel) === POP_WINDOW_WHEEL_TYPE.WHEEL_COMBO && this.formDataStart?.settings?.typesetting) {
      this.scopedRules.middleMobilePictureShow = false;
      const ts = this.formDataStart.settings.typesetting;
      const positionKey = getMiddlePageScopedField(this.currentFormKey, 'middleImgPosition');
      const currentValue = (ts as any)[positionKey] ?? ts.middleImgPosition;
      if (!(currentValue === 'left' || currentValue === 'right')) {
        Vue.set(ts as any, positionKey, 'right');
      }
    }
    this.handlePrivacyPositionChange();
    // }
  }

  @Watch('activePageSetting')
  changeActivePageSetting() {
    this.ensureDropdownRuleDefaults();
    this.ensureMarginRuleDefaults();
    this.normalizeTieredDiscountFormPage();
  }
  @Watch('formData.settings.rules.countDown')
  changeCountDown(val: number) {
    if (val > 60) {
      this.countDown = val / 60;
      this.countdownTime = 'minute';
    } else if (val === 60) {
      this.countdownTime = 'second';
      this.$nextTick(() => {
        this.countDown = 60 / 1;
      });
    } else {
      this.countdownTime = 'second';
      this.countDown = val;
    }
  }

  @Watch('currentFormList', { immediate: true })
  changeMiddleFormList(val: any) {
    if (val && val.length > 0) {
      this.formList = val;
    }
  }

  handlePrivacyPositionChange() {
    const val = this.scopedRules.middlePrivacyPosition || this.formDataStart?.settings?.rules?.privacyPosition;
    const styleMap = this.pageStyleMap['cartx-b-privacy__' + this.currentFormKey];
    // 嵌入弹窗都在button下面
    if (val === 'form' && this.formDataStart.triggerEventType !== 7) {
      // 跟随采集框：下间距6px，上间距0
      styleMap['margin-bottom'] = 6;
      styleMap['margin-top'] = 0;
    } else if (val === 'button' || this.formDataStart.triggerEventType === 7) {
      // 主按钮以下：下间距0，上间距6px
      styleMap['margin-bottom'] = 0;
      styleMap['margin-top'] = 6;
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  bgHandleError(e: any): void {
    this.bgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  bgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.bgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.currentMiddleImgUrl = res.data[0].url;
      this.bgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.bgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  bgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/webp" ||
      file.type === "image/png" ||
      file.type === "image/jpg";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.bgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  bgUploadUrlDelete() {
    this.bgUploadShow = false;
    this.currentMiddleImgUrl = '';
  }

  /**
   * 图片上传失败钩子函数
   */
  zpbgHandleError(e: any): void {
    this.zpbgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  zpbgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.zpbgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.currentMiddleBgImgUrl = res.data[0].url;
      this.zpbgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.zpbgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  zpbgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.zpbgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  zpbgUploadUrlDelete() {
    this.zpbgUploadShow = false;
    this.currentMiddleBgImgUrl = '';
  }

  /**
   * 图片上传失败钩子函数
   */
  pointHandleError(e: any): void {
    this.pointUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  pointHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.pointUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = res.data[0].url);
      this.pointUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.pointUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  pointBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.pointUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  pointUploadUrlDelete() {
    this.pointUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  logoHandleError(e: any): void {
    this.logoUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  logoHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.logoUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.currentMiddleLogoImgUrl = res.data[0].url;
      this.logoUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.logoUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  logoBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.logoUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  logoUploadUrlDelete() {
    this.logoUploadShow = false;
    this.currentMiddleLogoImgUrl = '';
  }

  // 左图上传

  /**
   * 图片上传失败钩子函数
   */
  leftAdImageHandleError(e: any): void {
    this.leftAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  leftAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.leftAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.currentMiddleLeftAdImage = res.data[0].url;
      this.leftAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.leftAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  leftAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.leftAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  leftAdImageUrlDelete() {
    this.leftAdImageShow = false;
    this.currentMiddleLeftAdImage = '';
    this.changeStart();
  }

  // 右图上传

  /**
   * 图片上传失败钩子函数
   */
  rightAdImageHandleError(e: any): void {
    this.rightAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  rightAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.rightAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.currentMiddleRightAdImage = res.data[0].url;
      this.rightAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.rightAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  rightAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.rightAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  rightAdImageUrlDelete() {
    this.rightAdImageShow = false;
    this.currentMiddleRightAdImage = '';
    this.changeStart();
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }

  /**
   * 图片上传失败钩子函数
   */
  textAreaHandleError(e: any): void {
    this.textAreaUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  textAreaHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.textAreaUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.currentMiddleTextAreaImgUrl = res.data[0].url;
      this.textAreaFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.textAreaUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  textAreaBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.textAreaUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  textAreaUploadUrlDelete() {
    this.textAreaUploadShow = false;
    this.currentMiddleTextAreaImgUrl = '';
    this.changeStart();
  }
  /**
   * 点击上传图片
   */
  textAreaClick() {
    window.gtagClick('form_edit_setTextImage', '弹窗_编辑订阅工具_设置文本区域图片');
  }

  /**
   * 检查某个登录方式是否已启用
   */
  isAuthEnabled(type: number): boolean {
    return this.formDataStart.settings.authList?.some(auth => auth.type === type) || false;
  }

  /**
   * 获取某个登录方式的 clientId
   */
  getAuthClientId(type: number): string {
    return this.formDataStart.settings.authList?.find(auth => auth.type === type)?.clientId || '';
  }

  /**
   * 切换登录方式启用状态
   */
  toggleAuthProvider(type: number, enabled: boolean) {
    if (!this.formDataStart.settings.authList) {
      this.$set(this.formDataStart.settings, 'authList', []);
    }
    
    if (enabled) {
      // 启用：添加到 authList
      if (!this.isAuthEnabled(type) && this.formDataStart.settings.authList) {
        this.formDataStart.settings.authList.push({
          type: type,
          clientId: ''
        });
      }
    } else {
      // 禁用：从 authList 中移除
      if (this.formDataStart.settings.authList) {
        const index = this.formDataStart.settings.authList.findIndex(auth => auth.type === type);
        if (index > -1) {
          this.formDataStart.settings.authList.splice(index, 1);
        }
      }
    }

    window.gtagClick('form_edit_signinwithGoogle', '弹窗_编辑订阅工具勾选google登录');
    this.changeStart();
  }

  /**
   * 更新 clientId
   */
  updateAuthClientId(type: number, clientId: string) {
    if (!this.formDataStart.settings.authList) {
      return;
    }
    const auth = this.formDataStart.settings.authList.find(auth => auth.type === type);
    if (auth) {
      auth.clientId = clientId;
      this.changeStart();
    }
  }

  /**
   * 校验 Google Client ID 格式
   * 只校验结尾是否为 .apps.googleusercontent.com
   */
  isValidGoogleClientId(clientId: string): boolean {
    return clientId.trim().endsWith('.apps.googleusercontent.com');
  }

  /**
   * 校验第三方登录配置
   * 如果启用了第三方登录，需要校验：
   * 1. clientId 是否已填写
   * 2. clientId 格式是否正确
   * 3. 是否有 email 采集项
   */
  validateAuthList(): boolean {
    if (!this.formDataStart.settings.authList || this.formDataStart.settings.authList.length === 0) {
      return true; // 没有启用第三方登录，校验通过
    }

    // 校验每个启用的第三方登录
    for (const auth of this.formDataStart.settings.authList) {
      // 1. 校验 clientId 是否已填写
      if (!auth.clientId || auth.clientId.trim() === '') {
        this.$message.error({
          message: '您已勾选添加第三方登录按钮，请输入Google client ID，再进行下一步操作',
          type: 'error',
          duration: 5000
        });
        return false;
      }

      // 2. 校验 clientId 格式是否正确
      if (!this.isValidGoogleClientId(auth.clientId)) {
        this.$message.error({
          message: 'Google Client ID 格式不正确，应为：xxx.apps.googleusercontent.com',
          type: 'error',
          duration: 5000
        });
        return false;
      }

      // 3. 校验是否有 email 采集项
      const hasEmail = this.formList.some((form: any) => form.type === 'Email');
      if (!hasEmail) {
        this.$message.error({
          message: '您已勾选添加第三方登录按钮，请添加Email表单后，再进行下一步操作',
          type: 'error',
          duration: 5000
        });
        return false;
      }
    }

    return true;
  }
}
